import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CartService } from 'src/app/services/cart.service';
import { LoginService } from 'src/app/services/login.service';
import { CommonService } from 'src/app/services/common.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';
import { UserData } from 'src/app/models/userData.model';
import * as moment from 'moment';

@Component({
  selector: 'app-mobile-product-cart-bottom',
  templateUrl: './mobile-product-cart-bottom.component.html',
  styleUrls: ['./mobile-product-cart-bottom.component.less']
})
export class MobileProductCartBottomComponent implements OnInit, OnChanges {
  @Input() productData: any;
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  
  isLogin: boolean = false;
  userData: UserData | undefined;
  quantity: number = 0;
  expectedDate: Date = new Date();
  disabledDate = (current: Date): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return current < today;
  };

  constructor(
    private cartService: CartService,
    private loginService: LoginService,
    private commonService: CommonService,
    private message: NzMessageService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.checkLoginStatus();
    this.initProductData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['productData'] && this.productData) {
      this.initProductData();
    }
  }

  checkLoginStatus(): void {
    this.loginService.userData$.subscribe((userData: UserData | null) => {
      this.userData = userData || undefined;
      this.isLogin = !!userData;
    });
  }

  initProductData(): void {
    if (this.productData) {
      const moq = this.productData.minimumOrderQuantity || this.productData.minumQty || 1;
      this.quantity = this.productData.quantity || moq;
      this.expectedDate = this.productData.expectedDate 
        ? new Date(this.productData.expectedDate) 
        : new Date();
    }
  }

  decrease(): void {
    const moq = this.getMoq();
    const newQuantity = this.quantity - moq;
    if (newQuantity >= moq) {
      this.quantity = newQuantity;
    } else {
      this.quantity = moq;
    }
  }

  increase(): void {
    const moq = this.getMoq();
    this.quantity = (this.quantity || 0) + moq;
  }

  getMoq(): number {
    return this.productData?.minimumOrderQuantity || this.productData?.minumQty || 1;
  }

  getStockQuantity(): number | null {
    return this.productData?.stockQuantity !== undefined && this.productData?.stockQuantity !== null
      ? this.productData.stockQuantity
      : null;
  }

  getStockStatus(): 'available' | 'low' | 'out' | null {
    const stockQty = this.getStockQuantity();
    if (stockQty === null) return null;
    if (stockQty === 0) return 'out';
    if (this.quantity <= stockQty) return 'available';
    return 'low';
  }

  quantityBlur(event: any): void {
    const value = event?.target?.value ? parseInt(event.target.value) : this.quantity;
    const moq = this.getMoq();
    if (value < moq) {
      this.quantity = moq;
    } else if (value % moq !== 0) {
      this.quantity = Math.ceil(value / moq) * moq;
    } else {
      this.quantity = value;
    }
  }

  chooseDate(): void {
    const oneWeekLater = moment().add(7, 'days');
    this.expectedDate = oneWeekLater.toDate();
  }

  async addToCart(): Promise<void> {
    if (!this.isLogin || this.userData?.queryUserPageInfoResDTO?.status !== 2) {
      this.message.warning(this.translate.instant('PLEASE_LOGIN_FIRST') || '请先登录');
      return;
    }

    if (!this.productData?.partNo) {
      this.message.error('产品信息不完整');
      return;
    }

    const params = {
      expectedDate: this.commonService.formatDateString(this.expectedDate),
      quantity: this.quantity,
      inputMaterialNumber: this.productData.partNo
    };

    try {
      await this.cartService.addToCart([params]);
      this.message.success(this.translate.instant('ADD_TO_CART_SUCCESSFULLY') || '已加入购物车');
      this.close();
    } catch (error) {
      this.message.error(this.translate.instant('ADD_TO_CART_FAILED') || '加入购物车失败');
    }
  }

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}

